import api from "./axiosInstance";

/**
 * @param {number} limit
 * @param {number} offset
 */
export const getSalesTags = async () => {
  const response = await api.get(
    `api/v1/sale-tags-config/`
  );
  return response.data;
};


export const updateSalesTags= async (payload) => {
  const response = await api.patch(
    `api/v1/sale-tags-config/`,
    payload
  );
  return response.data;
};



